import React from "react";
import "./style.css";

export default props => (
    <div className="loader">
        <img src={props.loadingIcon} alt="loading"/>
    </div>
);
